<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()"
  (b3-request-close)="close()"
  (b3-request-back)="close()">
  <b3-drawer-header
    heading="Detalhes do Projeto"
    show-back
    back-aria-label="Fechar detalhes do projeto">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="project-details-drawer" *ngIf="!isLoading && projectData; else loadingState">
      <b3-tag
        class="project-details-drawer__status"
        size="sm"
        variant="filled"
        [icon]="statusIcon"
        [tone]="statusTone"
        [label]="statusLabel">
      </b3-tag>

      <h2 class="project-details-drawer__section-title">ETAPA 1 - DADOS GERAIS</h2>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Nome do projeto</span>
        <span class="project-details-drawer__value">{{ projectData.projectName || '-' }}</span>
      </div>

      <div class="project-details-drawer__grid project-details-drawer__grid--2">
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">Conta registrador</span>
          <span class="project-details-drawer__value">{{ projectData.registerCode || '-' }}</span>
        </div>
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">Data de início</span>
          <span class="project-details-drawer__value">{{ projectData.projectStartDate || '-' }}</span>
        </div>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Atividade de linha de base</span>
        <span class="project-details-drawer__value">{{ baselineActivity }}</span>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Descrição</span>
        <p class="project-details-drawer__value project-details-drawer__value--description">
          {{ projectData.generalDetails || '-' }}
        </p>
      </div>

      <div class="project-details-drawer__grid project-details-drawer__grid--2">
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">Desenvolvedor</span>
          <span class="project-details-drawer__value">{{ developerPrincipal?.developerName || '-' }}</span>
        </div>
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">CPF/CNPJ</span>
          <span class="project-details-drawer__value">{{ developerPrincipal?.cpfCnpj || '-' }}</span>
        </div>
      </div>

      <div class="project-details-drawer__grid project-details-drawer__grid--2">
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">E-mail</span>
          <span class="project-details-drawer__value">{{ developerPrincipal?.email || '-' }}</span>
        </div>
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">Telefone</span>
          <span class="project-details-drawer__value">{{ developerPhoneLabel }}</span>
        </div>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <ng-container *ngIf="otherDevelopers.length; else emptyOtherDevelopers">
          <div class="project-details-drawer__developers-table">
            <div class="project-details-drawer__developers-row project-details-drawer__developers-row--header">
              <span class="project-details-drawer__label">Outros desenvolvedores</span>
              <span class="project-details-drawer__label">CPF/CNPJ</span>
            </div>
            <div
              *ngFor="let developer of otherDevelopers"
              class="project-details-drawer__developers-row">
              <span class="project-details-drawer__value">{{ developer.developerName || '-' }}</span>
              <span class="project-details-drawer__value">{{ developer.cpfCnpj || '-' }}</span>
            </div>
          </div>
        </ng-container>
        <ng-template #emptyOtherDevelopers>
          <div class="project-details-drawer__developers-table">
            <div class="project-details-drawer__developers-row project-details-drawer__developers-row--header">
              <span class="project-details-drawer__label">Outros desenvolvedores</span>
              <span class="project-details-drawer__label">CPF/CNPJ</span>
            </div>
            <div class="project-details-drawer__developers-row">
              <span class="project-details-drawer__value">-</span>
              <span class="project-details-drawer__value">-</span>
            </div>
          </div>
        </ng-template>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 2 - PROPRIEDADES
      </h2>

      <div
        *ngFor="let property of propertyLocations; let index = index"
        class="project-details-drawer__property-block">
        <p
          *ngIf="propertyLocations.length > 1"
          class="project-details-drawer__property-index">
          Propriedade {{ index + 1 }}
        </p>

        <div class="project-details-drawer__grid project-details-drawer__grid--2">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Proprietário</span>
            <span class="project-details-drawer__value">{{ property.ownerName }}</span>
          </div>
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">CPF/CNPJ</span>
            <span class="project-details-drawer__value">{{ property.ownerDocument }}</span>
          </div>
        </div>

        <div class="project-details-drawer__grid project-details-drawer__grid--2">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Município</span>
            <span class="project-details-drawer__value">{{ property.municipality }}</span>
          </div>
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">UF</span>
            <span class="project-details-drawer__value">{{ property.state }}</span>
          </div>
        </div>

        <div class="project-details-drawer__grid project-details-drawer__grid--2">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Coordenadas</span>
            <span class="project-details-drawer__value">{{ property.coordinates }}</span>
          </div>
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Hectares Totais</span>
            <span class="project-details-drawer__value">{{ property.totalHectares }}</span>
          </div>
        </div>

        <div class="project-details-drawer__grid project-details-drawer__grid--2">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Hectares Carbono</span>
            <span class="project-details-drawer__value">{{ property.carbonHectares }}</span>
          </div>
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Bioma</span>
            <span class="project-details-drawer__value">{{ property.biome }}</span>
          </div>
        </div>

        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">CAR</span>
          <span class="project-details-drawer__value">{{ property.car }}</span>
        </div>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 3 - METODOLOGIA
      </h2>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Metodologia</span>
        <span class="project-details-drawer__value">{{ methodologyLabel }}</span>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Link relatório</span>
        <a
          *ngIf="projectData.methodologyReportLink; else emptyReportLink"
          class="project-details-drawer__link"
          [href]="projectData.methodologyReportLink"
          target="_blank"
          rel="noopener noreferrer">
          {{ projectData.methodologyReportLink }}
          <b3-icon name="open_in_new" size="sm"></b3-icon>
        </a>
        <ng-template #emptyReportLink>
          <span class="project-details-drawer__value">-</span>
        </ng-template>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Descrição</span>
        <p class="project-details-drawer__value project-details-drawer__value--description">
          {{ projectData.methodologyDocumentDescription || '-' }}
        </p>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Documentos</span>
        <ng-container *ngIf="documentLinks.length; else emptyDocuments">
          <a
            *ngFor="let link of documentLinks"
            class="project-details-drawer__link project-details-drawer__document-link"
            [href]="link"
            target="_blank"
            rel="noopener noreferrer">
            {{ link }}
            <b3-icon name="open_in_new" size="sm"></b3-icon>
          </a>
        </ng-container>
        <ng-template #emptyDocuments>
          <span class="project-details-drawer__value">-</span>
        </ng-template>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 4 - CO-BENEFÍCIOS
      </h2>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">{{ selectedOdsCountLabel }}</span>
        <div class="project-details-drawer__ods-list" *ngIf="selectedOdsTags.length; else emptyOds">
          <b3-tag
            *ngFor="let odsTag of selectedOdsTags"
            class="project-details-drawer__ods-tag"
            size="sm"
            variant="filled"
            tone="neutral"
            [label]="odsTag">
          </b3-tag>
        </div>
        <ng-template #emptyOds>
          <span class="project-details-drawer__value">-</span>
        </ng-template>
      </div>

      <div class="project-details-drawer__field project-details-drawer__field--full">
        <span class="project-details-drawer__label">Outros co-benefícios</span>
        <p class="project-details-drawer__value project-details-drawer__value--description">
          {{ projectData.coBenefits || '-' }}
        </p>
      </div>

      <div class="project-details-drawer__actions">
        <b3-button
          *ngIf="showConfirmRmAction"
          type="button"
          variant="filled"
          tone="default"
          class="project-details-drawer__confirm-rm-btn"
          (b3-click)="openConfirmRmModal()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Confirmar recebimento do RM
        </b3-button>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          class="project-details-drawer__export-btn"
          (b3-click)="exportDetails()">
          Exportar Detalhes
        </b3-button>
      </div>
    </div>

    <ng-template #loadingState>
      <p class="project-details-drawer__loading">Carregando detalhes do projeto...</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>

<b3-modal
  *ngIf="showConfirmRmModal"
  [open]="showConfirmRmModal"
  overlay
  size="md"
  (b3-close)="onConfirmRmModalDismiss()">
  <b3-modal-header
    heading="Confirmar Recebimento"
    aria-level="2"
    icon="check_circle"
    icon-tone="success"
    close-aria-label="Fechar">
  </b3-modal-header>
  <b3-modal-body>
    <p class="project-details-drawer__modal-text">
      Deseja confirmar o recebimento do parecer do auditor ao Relatório de Adequação à Metodologia?
    </p>
  </b3-modal-body>
  <b3-modal-footer>
    <div class="project-details-drawer__modal-footer">
      <b3-button type="button" variant="outlined" tone="default" (b3-click)="onConfirmRmModalDismiss()">
        <b3-icon name="cancel" size="md"></b3-icon>
        Cancelar
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" (b3-click)="onConfirmRmModalConfirmed()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
